import { render, staticRenderFns } from "./DeleteDiscountDialog.vue?vue&type=template&id=7c2d1b3d&scoped=true&"
import script from "./DeleteDiscountDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDiscountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2d1b3d",
  null
  
)

export default component.exports